export const ptBRExpenses = {
  pageTitle: 'Despesas',
  loading: 'Carregando despesas...',
  errorLoad: 'Falha ao carregar despesas: {{error}}',
  noExpensesTitle: 'Nenhuma despesa este mes',
  noExpenses: 'Nenhuma despesa em {{year}}-{{month}}. Adicione sua primeira despesa ou verifique outro mes.',
  total: 'Total',
  monthTotal: 'Total do mes',
  moreActions: 'Mais acoes',
  accountFilterLabel: 'Conta',
  entriesSection: 'Entradas',
  paid: 'Pago',
  pending: 'Pendente',
  paymentProgress: 'Progresso de pagamento',
  paymentProgressAria: 'Progresso de pagamento',
  overdueHint: 'Inclui despesas que já venceram e estão em atraso',
  addExpense: '+ Adicionar Despesa',
  addButton: 'Adicionar',
  addExpenseItem: 'Despesa',
  addDepositItem: 'Deposito',
  allAccounts: 'Todas as Contas',
  accountBreakdown: 'Detalhamento por Conta',
  totalLabel: 'Total: ',
  paidPending: 'Pago: {{paid}} | Pendente: {{pending}}',
  statusPaid: '\u2713 Pago',
  statusOverdue: 'Em atraso',
  statusDue: 'Vence hoje',
  statusUpcoming: 'Proximo',
  dateLabel: 'Data',
  dueLabel: 'Vencimento',
  categoryLabel: 'Categoria',
  accountLabel: 'Conta',
  recurring: 'Recorrente',
  markPaid: 'Pago',
  edit: 'Editar',
  delete: 'Excluir',
  formDescription: 'Descricao',
  formDescriptionPlaceholder: 'Informe a descricao',
  formDescriptionSearchPlaceholder: 'Digite para buscar descricoes...',
  formDescriptionNoResults: 'Nenhuma descricao encontrada',
  formAmount: 'Valor',
  formDate: 'Data',
  formDueDate: 'Data de vencimento (Opcional)',
  formMarkAsPaid: 'Marcar como pago',
  formCategory: 'Categoria (Opcional)',
  formCategoryNone: '-- Nenhuma --',
  categorySelectorSearch: 'Buscar categorias...',
  categorySelectorEmpty: 'Nenhuma categoria encontrada.',
  categorySelectorSuggested: 'Sugerida',
  formAccount: 'Conta debitada',
  formAccountRequired: 'Conta debitada *',
  formAccountSelect: '-- Selecionar Conta --',
  formNotes: 'Observacoes (Opcional)',
  formNotesPlaceholder: 'Adicione uma observacao sobre esta despesa...',
  formSaving: 'Salvando...',
  formCreate: 'Criar Despesa',
  formUpdate: 'Atualizar Despesa',
  formError: 'Ocorreu um erro',
  modalAdd: 'Adicionar Despesa',
  modalEdit: 'Editar Despesa',
  deleteTitle: 'Excluir Despesa',
  deleteMessage: 'Tem certeza que deseja excluir "{{description}}"? Esta acao nao pode ser desfeita.',
  deleteConfirm: 'Excluir',
  validationAmountRequired: 'Valor e obrigatorio',
  validationDescriptionRequired: 'Descricao e obrigatoria',
  validationDescriptionTooLong: 'Descricao muito longa',
  validationDateRequired: 'Data e obrigatoria',
  validationNotesTooLong: 'Observacoes deve ter no maximo 500 caracteres',
  toastCreated: 'Despesa criada',
  toastUpdated: 'Despesa atualizada',
  toastDeleted: 'Despesa excluida',
  toastMarkedPaid: 'Marcado como pago',
  toastMarkedUnpaid: 'Marcado como nao pago',
  toastCreateError: 'Erro ao criar despesa',
  toastUpdateError: 'Erro ao atualizar despesa',
  toastDeleteError: 'Erro ao excluir despesa',
  toastMarkPaidError: 'Erro ao atualizar status',
  installmentProgress: '{{current}}/{{total}} parcelas',
  paidAtLabel: 'Pago em {{date}}',
  formPaidAt: 'Data do pagamento',
  filterAll: 'Todas',
  filterPaid: 'Pagas',
  filterUnpaid: 'Pendentes',
  noFilteredExpenses: 'Nenhuma despesa encontrada com este filtro',
  receipt: {
    upload: 'Anexar comprovante',
    preview: 'Ver comprovante',
    delete: 'Excluir comprovante',
    previewTitle: 'Comprovante',
    openInDrive: 'Abrir no Drive',
    deleteConfirmCancel: 'Cancelar',
    loading: 'Enviando...',
    previewLoading: 'Carregando comprovante...',
    previewError: 'Erro ao carregar comprovante',
  },
  files: {
    uploadSuccess: 'Arquivo enviado',
    uploadError: 'Falha ao enviar arquivo',
    deleteSuccess: 'Arquivo removido',
    deleteError: 'Falha ao remover arquivo',
    deleteConfirmTitle: 'Remover arquivo?',
    deleteConfirmDescription: 'O arquivo sera removido permanentemente do Google Drive.',
    deleteConfirmAction: 'Remover',
    deleteConfirmCancel: 'Cancelar',
    rootFolderRequired: 'Selecione uma pasta raiz nas Configuracoes antes de enviar arquivos',
  },
  detail: {
    amount: 'Valor',
    date: 'Data',
    dueDate: 'Vencimento',
    paidAt: 'Pago em',
    category: 'Categoria',
    account: 'Conta',
    notes: 'Observacoes',
    status: 'Status',
    billSummary: 'Resumo da Conta',
    billAmount: 'Valor da Conta',
    recurrence: 'Recorrencia',
    monthly: 'Mensal',
    yearly: 'Anual',
    unlimited: 'Ilimitado',
    active: 'Ativa',
    inactive: 'Inativa',
    installmentProgress: '{{current}} de {{total}} parcelas',
    relatedExpenses: 'Despesas Relacionadas',
    receipt: 'Comprovante',
    files: 'Comprovantes',
    addFile: 'Adicionar arquivo',
    billNotes: 'Observações da conta',
    billFiles: 'Arquivos da conta',
    noBill: 'Despesa manual',
    loading: 'Carregando detalhes...',
    error: 'Erro ao carregar detalhes da despesa',
    markAsPaid: 'Marcar como Pago',
    markAsUnpaid: 'Marcar como Nao Pago',
    edit: 'Editar',
    delete: 'Excluir',
    editAmount: 'Editar valor',
    saveAmount: 'Salvar valor',
    cancelAmount: 'Cancelar',
    amountRequired: 'Informe um valor válido',
    share: 'Compartilhar',
    shareCopied: 'Detalhes copiados!',
    shareFailed: 'Não foi possível compartilhar ou copiar os detalhes',
    shareTitle: 'Nomi — Despesa',
    shareDescription: 'Descrição',
    shareAmount: 'Valor',
    shareCategory: 'Categoria',
    shareDate: 'Data',
    shareStatus: 'Status',
  },
  search: {
    title: 'Buscar Despesas',
    placeholder: 'Buscar por descricao...',
    filterCategory: 'Categoria',
    filterAccount: 'Conta',
    filterStatus: 'Status',
    filterDateRange: 'Periodo',
    filterFrom: 'De',
    filterTo: 'Ate',
    allCategories: 'Todas as categorias',
    allAccounts: 'Todas as contas',
    allStatuses: 'Todos',
    paidOnly: 'Pago',
    unpaidOnly: 'Pendente',
    resultCount: '{{count}} resultados',
    noResults: 'Nenhuma despesa encontrada',
    noResultsHint: 'Tente palavras diferentes ou ajuste os filtros',
    loading: 'Buscando...',
    clearFilters: 'Limpar filtros',
    viewInMonth: 'Ver no mes',
  },
  deposit: {
    sectionTitle: 'Depositos',
    addDeposit: '+ Adicionar Deposito',
    modalAdd: 'Adicionar Deposito',
    modalEdit: 'Editar Deposito',
    formDescription: 'Descricao (Opcional)',
    formDescriptionPlaceholder: 'Informe a descricao',
    formAmount: 'Valor',
    formDate: 'Data',
    formAccount: 'Conta *',
    formAccountSelect: '-- Selecionar Conta --',
    formSaving: 'Salvando...',
    formCreate: 'Criar Deposito',
    formUpdate: 'Atualizar Deposito',
    formError: 'Ocorreu um erro',
    deleteTitle: 'Excluir Deposito',
    deleteMessage: 'Tem certeza que deseja excluir este deposito de {{amount}}? Esta acao nao pode ser desfeita.',
    deleteConfirm: 'Excluir',
    toastCreated: 'Deposito criado',
    toastUpdated: 'Deposito atualizado',
    toastDeleted: 'Deposito excluido',
    toastCreateError: 'Erro ao criar deposito',
    toastUpdateError: 'Erro ao atualizar deposito',
    toastDeleteError: 'Erro ao excluir deposito',
    validationAmountRequired: 'Valor e obrigatorio',
    validationDateRequired: 'Data e obrigatoria',
    badgeLabel: 'Deposito',
    dateLabel: 'Data',
    accountLabel: 'Conta',
  },
  export: {
    button: 'Exportar',
    csvMonth: 'CSV (este mes)',
    pdfMonth: 'PDF (este mes)',
    csvYear: 'CSV (ano inteiro)',
    downloading: 'Exportando...',
    success: 'Exportacao concluida',
    error: 'Falha ao exportar',
  },
} as const;
